export default __webpack_public_path__ + "static/media/dl.d8c9807d.png";